import { useNavigate } from "react-router-dom";
import Icon3D from "@/components/base/Icon3D";

interface Action {
  label: string;
  hint: string;
  icon: string;
  to: string;
  tone: "primary" | "accent" | "secondary" | "neutral";
}

const actions: Action[] = [
  { label: "Registrar compra", hint: "Agrega inventario", icon: "ri-shopping-cart-2-line", to: "/compras/nueva", tone: "primary" },
  { label: "Registrar venta", hint: "Cobra y descuenta", icon: "ri-shopping-bag-3-line", to: "/ventas/nueva", tone: "accent" },
  { label: "Registrar gasto", hint: "Gasto adicional", icon: "ri-wallet-3-line", to: "/gastos/nuevo", tone: "secondary" },
  { label: "Registrar devolución", hint: "Reembolsos y pérdidas", icon: "ri-arrow-go-back-line", to: "/devoluciones/nueva", tone: "neutral" },
  { label: "Escanear factura", hint: "Foto o PDF", icon: "ri-camera-line", to: "/documentos/nuevo", tone: "secondary" },
  { label: "Ver documentos", hint: "Tus facturas", icon: "ri-file-text-line", to: "/documentos", tone: "neutral" },
  { label: "Consultar historial", hint: "Todos los movimientos", icon: "ri-history-line", to: "/movimientos", tone: "primary" },
];

const toneMap: Record<Action["tone"], string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-700",
  neutral: "bg-background-200 text-foreground-600",
};

export default function QuickActions() {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-2 gap-3">
      {actions.map((action, index) => {
        const isLast = index === actions.length - 1;
        return (
          <button
            key={action.label}
            type="button"
            onClick={() => navigate(action.to)}
            className={`flex items-center gap-3 rounded-3xl border border-background-200/70 bg-background-50 p-3.5 text-left shadow-card active:scale-[0.98] transition-transform ${
              isLast ? "col-span-2" : ""
            }`}
          >
            <span className={`flex h-10 w-10 flex-none items-center justify-center rounded-2xl ${toneMap[action.tone]}`}>
              <Icon3D icon={action.icon} tone={action.tone} size={24} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-[13px] font-semibold leading-tight text-foreground-900">
                {action.label}
              </span>
              <span className="mt-0.5 block truncate text-[10px] text-foreground-500">
                {action.hint}
              </span>
            </span>
            <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-add-line text-base" />
            </span>
          </button>
        );
      })}
    </div>
  );
}